import ErrorBoundary from './components/ErrorBoundary';
import GlobalErrorBoundary from './components/GlobalErrorBoundary';
import { useErrorHandler } from './components/UseErrorHandler/UseErrorHandler';

export default ErrorBoundary;
export { GlobalErrorBoundary, useErrorHandler };
